import {
  computed,
  inject,
  Injectable,
  linkedSignal,
  WritableSignal,
} from '@angular/core';
import { IUserInfo, RoleTags } from '@cardium/contracts';
import { rxResource } from '@angular/core/rxjs-interop';
import { AuthService } from '@cardium/features/auth/data-access';
import { UserApiService } from './user-api.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly authService = inject(AuthService);
  private readonly userApiService = inject(UserApiService);

  private readonly isAuthenticated = computed(() =>
    this.authService.isAuthenticated() ? true : undefined,
  );

  private readonly userResource = rxResource({
    params: () => this.isAuthenticated(),
    stream: () => this.userApiService.getMe(),
  });

  readonly #user: WritableSignal<IUserInfo | null> = linkedSignal({
    source: () => this.userResource.value(),
    computation: (current, previous) => {
      if (!current) return previous?.value ?? null;
      return current;
    },
  });

  public readonly isLoading = this.userResource.isLoading;
  public readonly user = this.#user.asReadonly();

  public readonly isLaborant = computed(() => {
    return !!this.user()?.tags?.includes(RoleTags.LABORANT);
  });
}
